import loggerManager from './log/logger-manager';
import { getBusibuff } from './sso/sso-decoder';
import { performanceNow } from './utils';

const textDecoder = typeof TextDecoder !== 'undefined' ? new TextDecoder() : undefined;

/**
 * @param {string} options.url url 地址
 * @param {string} options.body 需要传的data
 * @param {string} options.method 方法
 * @param {number} options.timeout 超时时间
 */
export function http({
  url,
  body,
  method = 'POST',
  timeout,
  priority
}: {
  url: string | URL;
  body?: BodyInit | XMLHttpRequestBodyInit;
  method?: string;
  timeout?: number;
  priority?: RequestPriority;
}) : Promise<{ data: any }> {
  return new Promise((resolve, reject) => {
    if ('fetch' in window) {
      return fetch(url, { method, body, priority })
        .then(response => response.clone().json()
          .then(
            data => ({ data }),
            () => response.arrayBuffer().then(bytesData => {
              // 解析 sso 回包
              const data = getBusibuff(new Uint8Array(bytesData));
              // 解析失败时, 返回字符串
              return { data: data || (textDecoder ? textDecoder.decode(bytesData) : bytesData) };
            })
          ))
        .then(resolve, reject);
    }
    const xhr = new XMLHttpRequest();
    xhr.onreadystatechange = () => {
      if (xhr.readyState !== 4) {
        return;
      }
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          const result = JSON.parse(xhr.response);
          resolve({ data: result });
        } catch (e) {
          resolve({ data: xhr.response });
        }
      } else {
        reject({
          status: xhr.status,
          statusText: xhr.statusText || 'request failed!'
        });
      }
    };
    xhr.timeout = timeout || 5000;
    xhr.open(method, url, true);
    // @ts-ignore
    xhr.send(body);
  });
}

export async function compressJSON(data: any): Promise<ArrayBuffer|string> {
  const now = performanceNow();
  const stringifyData = JSON.stringify(data);
  try {
    // 一般 MTU 在 1500 字节，超过 2800 字节（考虑 tcp header 大概是 2 个 MTU）的情况下，开启压缩。
    if (!CompressionStream || stringifyData.length <= 2800) return stringifyData;
    const stream = new Blob([stringifyData], { type: 'application/json' }).stream();
    const compressedStream = stream.pipeThrough(new CompressionStream('gzip'));
    const compressedResponse = await new Response(compressedStream);
    const blob = await compressedResponse.blob();
    const arrayBuffer = await blob.arrayBuffer();
    loggerManager.debug(`compressJSON ${stringifyData.length} -> ${arrayBuffer.byteLength} ${performanceNow() - now}ms`);
    return arrayBuffer;
  } catch (error) {
    return stringifyData;
  }
}
